import React from 'react'
import './Banner.scss'
import {Link} from 'react-router-dom'
import {map} from 'lodash'
import { Button, Icon, Image, Popup } from 'semantic-ui-react'
import trailer from '../../video/trailer.mp4'
import db from '../../utils/firebase'
import Swal from 'sweetalert2'
import { useAuth } from '../../context/authContext'
import ReactPlayer from 'react-player'





export default function Banner() {

    
    const {user}=useAuth()
    const [dataBanner, setDataBanner] = React.useState([])
    const [show, setShow] = React.useState(false)
    const [reproducir,setReproducir] = React.useState(false)
    const [showbanner,setShowBaner]=React.useState("image")
    const  timeShow= 2500

    
    const truncate = (string, n) => string?.length > n ? `${string.substr(0, n-1)} ...` : string 

    const detalle = navigator.userAgent
                        let regExp = /android|iphone|kindle|ipad/i;
                        let isMobile = regExp.test(detalle)
 
    
    React.useEffect(() =>{
        
            db.collection("peliculas").where("title" ,"==" ,"sound of freedom").get().then((response) =>{
                const arrayTitle = []
                map(response.docs, album =>{
                    const data = album.data()
                    data.id = album.id
                    arrayTitle.push(data)
                })
                setDataBanner(arrayTitle)
            }).finally(()=>{
                setTimeout(()=>{

                    setReproducir(true)
                },1000)

            })

    },[])
    

    const handleOpen = () =>{
        setShow(true)
        let timeout = setTimeout(() =>{
            setShow(false)
        },timeShow)

    }

    const handleClose = () =>{
        setShow(false)

    }
    
    
    

     /*   Swal.fire(
            
            
            {
            title: `Hola! ${user?.displayName}`,
            confirmButtonColor:"#84507f",
            text:"SERIES y NOVELAS YA ESTA DISPONIBLE! no olvides recargar la pagina."
            
            
            
            })
    */
    
    
    return (
        <div className="banner" >
                <div className="banner-video" >
                    {
                        showbanner==="image"?(
                            <div className='containerBannerImage' >
                                <Image
                                    src="https://firebasestorage.googleapis.com/v0/b/playaf-f2f01.appspot.com/o/banner.png?alt=media&token=6cd3f199-03fd-412f-84f2-30bd597e3ed8"
                                    className='imagebanner'
                                />
                            </div>

                        ):(

                            isMobile ? (
    
                                     <div className='container_react_mobile' >
                                            <ReactPlayer
                                                url={trailer}
                                                playing={reproducir}
                                                muted={!reproducir ? true :false}
                                                className="video"
                                                loop
                                                
                                                
                                            />
    
                                    </div>
    
                            ):(
    
                                    <div className='container_react' >
                                            <ReactPlayer
                                                url={trailer}
                                                playing={reproducir}
                                                muted={!reproducir ? true :false}
                                                className="video"
                                                loop
                                                
                                                
                                            />
    
                                    </div>
                            )
                        )
                    }

                           
                        <div className="sombra-banner" />
                            <div className="banner-texto" >
                                <h1>{dataBanner[0]?.title}</h1>
                                <Link to={`/pelicula/${dataBanner[0]?.uuidPoster}`} >
                                    <Button >Play</Button>
                                </Link>
                                 
                                    <Button
                                        icon={
                                            <Icon
                                                name='volume up'
                                                onClick={()=>setReproducir(!reproducir)}
                                                className="butttomPlay"
                                                size={isMobile ? "large":"large"}
                                            />
                                        }
                                    />

                                <div className="banner-description" >

                                    {
                                        truncate(`${dataBanner[0]?.description}`,100)
                                    }
                                </div>
                            </div>
                            
                </div>
                            <div className="sombra-banner" />
                            
        </div>

        
    )
}
